import {  useContext, useEffect, useState } from "react";
import {
	BannerState,
	PBanner,
	PButton,
	PSpinner, PText
} from "@porsche-design-system/components-react";

import UserContext, {UserContextType} from "../../store/UserContext";
import { useModelState } from "../../store/ModelContext";
import Dropdown from "../../components/dropdown/dropdown";
import { GetLimitationNumberResponse, LimitationNumber, SaveLimitationNumberRequest, State } from "../../store/limitationNumber";
import { getLimitationNumbersByOrderTypeImporterAndState, transferLimitationNumber } from "../../api/LimitationNumberService";
import { getAllImporter } from "../../api/ModelImporterService";
import { Importer } from "../../store/importer";
import { ReservationResponse } from "../../store/response";
import { Grid } from "@react-css/grid";
import { Flex } from "@react-css/flex";

type Banner = {
	state: BannerState;
	title: string;
	description: string;
	duration: number;
};

export function TransferReservationTab(props : any) {

	const { partnerNumber, lenaAuthToken } = useContext<UserContextType>(UserContext);
	const modelContextState = useModelState();
	const [showInfoBanner, setShowInfoBanner] = useState<boolean>(false);
	const [showTransferReservationBanner, setShowTransferReservation] = useState<boolean>(false);
	const [limitedEditionNrList, setLimitedEditionNrList] = useState<Array<number>>([]);
	const [selectedLimitedEditionNr, setSelectedLimitedEditionNr] = useState<string>("");
	const [importerList, setImporterList] = useState<Array<string>>([]);
	const [selectedImporterNr, setSelectedImporterNr] = useState<string>("");
	const [loading, setLoading] = useState<boolean>(false);
	const [updateLists, setUpdateLists] = useState<boolean>(props.triggerUpdateLists);

	const initialBanner: Banner = {
		state: "info",
		title: "",
		description: "",
		duration: 6000
	};
	const [infoBanner, setInfoBanner] = useState(initialBanner);

	const showBanner = (message : string, resultState : BannerState) => {
		let bannerInfo: Banner = {
			state: resultState,
			title: "LENA Notification",
			description: message,
			duration: 6000
		};
		setInfoBanner(bannerInfo);
		setShowInfoBanner(true);
		setTimeout(() => {
			setShowInfoBanner(false);
		}, bannerInfo.duration);
	};

	useEffect(() => {
		let reservationDataList: number[] = [];
		let importerDataList: string[] = [];
		resetFields();
		if (modelContextState.globalOrderType !== "" && ( updateLists || props.triggerUpdateLists)) {
			setLoading(true);
			getLimitationNumbersByOrderTypeImporterAndState(lenaAuthToken, modelContextState.globalOrderType, partnerNumber, State.RESERVED)
				.then((response: GetLimitationNumberResponse) => {
					response.reservationResponseList.forEach((reservation: LimitationNumber) => {
						reservationDataList[reservation.limitedNumber] = reservation.limitedNumber;
					});
					setLimitedEditionNrList(reservationDataList);
					setLoading(false)
				})
				.catch((error) => {
					console.log(error);
				});

			getAllImporter(lenaAuthToken)
				.then((response: Importer[]) => {
					response.forEach((importer) => {
						let description = importer.description === null ? "" : " - " + importer.description
						importerDataList[importer.importer] = importer.importer + description
					});
					setImporterList(importerDataList);
				})
				.catch((error) => {
					console.log(error);
				});
			setUpdateLists(false);
		}
	}, [lenaAuthToken, props.triggerUpdate, modelContextState.globalOrderType, partnerNumber, updateLists, props.triggerUpdateLists]);

	function handleTransferReservation() {
		if (modelContextState.globalOrderType === "") {
			showBanner("Please select a model.", "error");
		} else if (selectedLimitedEditionNr === "" || selectedImporterNr === "") {
			showBanner("Please select a limitation number and an importer.", "error");
		} else {
			setShowTransferReservation(false);
			setTimeout(() => {
				setShowTransferReservation(true);

			}, 100);
		}
	}

	function handleTransferReservationConfirm() {
		setShowTransferReservation(false);
		setLoading(true);

		let saveReservationRequest: SaveLimitationNumberRequest = {
			orderType: modelContextState.globalOrderType,
			limitedNumber: parseInt(selectedLimitedEditionNr),
			partnerNumber: selectedImporterNr,
			reservationState: State.RESERVED
		};
		transferLimitationNumber(lenaAuthToken, saveReservationRequest)
			.then((response : ReservationResponse) => {
				if(response.status === 200){
					showBanner("Limitation number " + selectedLimitedEditionNr + " transferred successfully to importer " + selectedImporterNr + ".", "info");
					resetFields();
					setUpdateLists(true);
				}else{
					showBanner(response.message, "error");
				}
				setLoading(false);
			})
			.catch((error) => {
				showBanner(error.message, "error");
				setLoading(false);
			});
	}

	function handleCancelTransferReservation() {
		setShowTransferReservation(false);
	}

	function resetFields () {
		let dropdownClearButtons : HTMLCollectionOf<Element> =  document.getElementsByClassName("clear_container__clear-button");
		for(let i=0; i<dropdownClearButtons.length; i++){
			let btn = dropdownClearButtons[i] as HTMLDivElement;
			btn.click();
		}
	}

	return (
		<div>
			{showInfoBanner && (
				<PBanner autoFocus={false} state={infoBanner.state} dismissButton={false} className="create-model__banner_position"  open inert
				heading={infoBanner.title}>
					<span slot="description">{infoBanner.description}</span>
				</PBanner>
			)}
			{showTransferReservationBanner && (
				<PBanner
					autoFocus={false}
					dismissButton={true}
					onDismiss={() => handleCancelTransferReservation()}
					className="create-model__banner_position delete-confirm-banner" open inert={false}
					heading={"Do you really want to transfer limitation number " + selectedLimitedEditionNr + " to importer " + selectedImporterNr + "?"}>
					<div slot="description" className="delete-confirm-banner__description">
						<PButton variant="secondary" className="confirm-button" autoFocus={false} onClick={() => handleCancelTransferReservation()} inert={false}>
							Cancel
						</PButton>
						<PButton variant="primary" autoFocus={false} className="confirm-button" onClick={() => handleTransferReservationConfirm()} inert={false}>
							Ok
						</PButton>
					</div>
				</PBanner>
			)}
				<div>
					<Grid autoFlowColumn={true} columns='[first] 40% [line2] 20% [line3] 40%'>
						<Grid.Item columnStart={1}>
							<Dropdown
								className={"importer-transfer-input"}
								placeholder={"Limitation number to be transferred"}
								value={''}
								onChange={(value) => {
									if (value !== selectedLimitedEditionNr) {
										setSelectedLimitedEditionNr(value);
									}
								}}
								data={limitedEditionNrList}
								multipleSelections={false}
								clearable={true}
								searchable={true}
								showTooltip={false}
								label={"Limited Edition Number"}
							/>
						</Grid.Item>
						<Grid.Item justifySelfCenter={true}>
						<PText  className={"importer-transfer-text"}  autoFocus={false} inert={true}>transfer to: </PText>
						</Grid.Item>
						<Grid.Item justifySelfStretch={true}>
							<Dropdown
								className={"importer-transfer-input"}
								placeholder={"Importer"}
								value={""}
								onChange={(value) => {
									if (value !== selectedImporterNr) {
										setSelectedImporterNr(value);
									}
								}}
								data={importerList}
								multipleSelections={false}
								clearable={true}
								searchable={true}
								showTooltip={false}
								label={"Importer"}
							/>
						</Grid.Item>
					</Grid>
					<Flex row={true} justifyContent={"flex-center"}>
						{loading && <PSpinner className={"spinner"} autoFocus={false} size={{ base: "small", l: "medium" }} inert />}
					</Flex>
						<Flex row={true} justifyContent={"flex-end"} style={{marginTop: "20px"}}>
							<PButton className="button cancel-button" variant={"secondary"} autoFocus={false} onClick={() => resetFields()} inert={false}>Cancel</PButton>
							<PButton className="button" variant={"primary"} autoFocus={false} onClick={() => handleTransferReservation()} inert={false}>
								Transfer
							</PButton>
						</Flex>

				</div>
		</div>
	);
}
